import type { LineItemGroup } from '@payaca/types/lineItemGroupTypes';
import { FC, type JSX } from 'react';

import { Modal } from '@payaca/ambrosia';
import ListedItemGroupsControl from '../listedItemGroupsControl/ListedItemGroupsControl';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSelectItemGroup: (itemGroup: LineItemGroup) => void;
};
const SelectItemGroupModal: FC<Props> = ({
  isOpen,
  onClose,
  onSelectItemGroup,
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      title="Select an item group"
      onClose={onClose}
      size="md"
    >
      <Modal.Body>
        <ListedItemGroupsControl
          onClick={(lineItemGroup: any) => {
            onSelectItemGroup(lineItemGroup);
          }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default SelectItemGroupModal;
